export const API_URL_WORKSPACE: string = "https://api.workspace.vegait.rs";
